/* @ngInject */
function CampaignBriefingController ($scope, $rootScope, $translate, CampaignService, ToastService, SegmentService, ConfirmationModalService) {
  $scope.isEditing = false
  $scope.briefing = {}
  $scope.oldBriefing = {}
  $scope.minDeliveryDate = $scope.campaign.status === 'IN_PROGRESS' ? new Date($scope.campaign.deliveryDate) : $scope.campaign.startDate

  $scope.mandatoryFields = {
    title: {
      error: false
    },
    startDate: {
      error: false
    },
    deliveryDate: {
      error: false
    },
    expireCampaignContentsOnFinish: {
      error: false
    }
  }

  const api = {
    _setDateVisualization,
    _updateCampaign,
    _shouldShowWarningDialog,
    _showWarningDialog
  }

  this.getApi = () => api

  activate()

  function activate () {
    $scope.briefing = angular.copy($scope.campaign)

    api._setDateVisualization()
  }

  function _setDateVisualization () {
    const startDate = moment($scope.briefing.startDate)
    const deliveryDate = moment($scope.briefing.deliveryDate)
    const formattedStartDate = startDate.format('DD MMM YYYY')
    const formattedDeliveryDate = deliveryDate.format('DD MMM YYYY')

    $scope.dateVisualization = `${formattedStartDate} -> ${formattedDeliveryDate}`
  }

  function isFieldsValid () {
    const isValid = true
    if (!$scope.briefing.title) {
      $scope.mandatoryFields.title.error = true
      ToastService.showErrorToast($translate.instant('requiredField'))
      return !isValid
    }

    if (!$scope.briefing.startDate) {
      $scope.mandatoryFields.startDate.error = true
      ToastService.showErrorToast($translate.instant('requiredField'))
      return !isValid
    }

    if (!$scope.briefing.deliveryDate) {
      $scope.mandatoryFields.deliveryDate.error = true
      ToastService.showErrorToast($translate.instant('requiredField'))
      return !isValid
    }

    $scope.mandatoryFields.startDate.error = false
    $scope.mandatoryFields.title.error = false
    $scope.mandatoryFields.deliveryDate.error = false

    return isValid
  }

  $scope.editBriefing = function () {
    $scope.oldBriefing = angular.copy($scope.briefing)
    $scope.isEditing = true
  }

  $scope.saveBriefing = function () {
    if (!isFieldsValid()) return

    if (api._shouldShowWarningDialog()) {
      api._showWarningDialog()
      return
    }

    api._updateCampaign()
  }

  $scope.cancelBriefing = function () {
    $scope.briefing = angular.copy($scope.oldBriefing)
    $scope.isEditing = false
  }

  $scope.handleChangeDate = function (dateAttribute, event) {
    $scope.briefing[dateAttribute] = event?.detail?.date
    api._setDateVisualization()
  }

  $scope.onChangeTitle = (event) => {
    $scope.briefing.title = event?.detail?.value
  }

  $scope.onChangeExpireContentOnCampaignFinish = (event) => {
    $scope.briefing.expireCampaignContentsOnFinish = event?.detail?.value ?? false
  }

  function _updateCampaign () {
    const campaignId = $scope.briefing.id
    const campaignData = {
      title: $scope.briefing.title,
      status: $scope.campaign.status,
      startDate: $scope.briefing.startDate,
      deliveryDate: $scope.briefing.deliveryDate,
      expireCampaignContentsOnFinish: $scope.briefing.expireCampaignContentsOnFinish
    }

    CampaignService.updateCampaign(campaignId, campaignData)
      .then((response) => {
        SegmentService.track('campaign-briefing-change', {
          campaign_id: response.id
        })
        $scope.isEditing = false
        /**
         * Importante: mutar as propriedades para evitar quebrar o binding bidirecional entre ng-if scope boundaries
         */
        $scope.campaign.title = $scope.briefing.title
        $scope.campaign.status = $scope.briefing.status
        $scope.campaign.startDate = $scope.briefing.startDate
        $scope.campaign.deliveryDate = $scope.briefing.deliveryDate
        $scope.campaign.expireCampaignContentsOnFinish = $scope.briefing.expireCampaignContentsOnFinish

        ToastService.showSuccessToast($translate.instant('campaignEdit.briefing.successChangeMessage'))
        $rootScope.$broadcast('reload-arts-page', { emitter: 'updateCampaign', campaignId })
      })
      .catch(ToastService.defaultErrorToast)
  }

  function _shouldShowWarningDialog () {
    return $scope.briefing.startDate !== $scope.oldBriefing.startDate || $scope.briefing.deliveryDate !== $scope.oldBriefing.deliveryDate
  }

  function _showWarningDialog () {
    ConfirmationModalService.createModal({
      title: $translate.instant('warning'),
      description: $translate.instant('campaignBriefingWarning'),
      buttonConfirmText: $translate.instant('yesUpdate'),
      onConfirm: api._updateCampaign
    })
  }
}

export { CampaignBriefingController }
